<template>
  <main class="deposits" :class="{ sideBarClosed: isToggleSideBar }">
    <div class="searchPanel">
      <div class="searchPanel__input">
        <p class="searchPanel__input__label">Id:</p>
        <div class="searchPanel__input-wrapper">
          <input type="text" placeholder="id" v-model="searchPanel.id" />
        </div>
      </div>
      <div class="searchPanel__input">
        <p class="searchPanel__input__label">Payment System:</p>
        <div class="searchPanel__input-wrapper">
          <input type="text" placeholder="id" v-model="searchPanel.paymentSystem" />
        </div>
      </div>
      <div class="searchPanel__input">
        <p class="searchPanel__input__label">User Id:</p>
        <div class="searchPanel__input-wrapper">
          <input type="text" placeholder="user id" v-model="searchPanel.userId" />
        </div>
      </div>
      <div class="searchPanel__input">
        <p class="searchPanel__input__label">Payment system invoice:</p>
        <div class="searchPanel__input-wrapper">
          <input
            type="text"
            placeholder="Payment system invoice"
            v-model="searchPanel.paymentSystemInvoice"
          />
        </div>
      </div>
      <div class="searchPanel__input">
        <p class="searchPanel__input__label">Status:</p>
        <div class="searchPanel__select" @click="openSelectStatus">
          <p>{{ searchPanel.status ? searchPanel.status : 'Выберите статус' }}</p>
          <img
            :class="{ rotate: selectStatusOpen }"
            src="../../assets/images/down-arrow.svg"
            alt="open"
          />
        </div>
        <div class="searchPanel__select__dropDown" v-if="selectStatusOpen">
          <span
            @click="selectStatus(status)"
            v-for="status in statusArray"
            class="searchPanel__select__dropDown__iteem"
          >
            {{ status }}
          </span>
        </div>
      </div>
      <div class="searchPanel__input">
        <p class="searchPanel__input__label">Currency:</p>
        <div class="searchPanel__select" @click="openSelect">
          <p>{{ searchPanel.currency ? searchPanel.currency : 'Выберите валюту' }}</p>
          <img
            :class="{ rotate: selectOpen }"
            src="../../assets/images/down-arrow.svg"
            alt="open"
          />
        </div>
        <div class="searchPanel__select__dropDown" v-if="selectOpen">
          <span
            @click="selectCurrency(key)"
            v-for="(currency, key) in currencyMap"
            class="searchPanel__select__dropDown__iteem"
          >
            {{ currency }}
          </span>
        </div>
      </div>
      <div class="checkbox">
        <span :class="{ active: searchPanel.isStatusApproved }" @click="approvedCheckBox"
          >Status Approved</span
        >
      </div>
      <div class="searchButton">
        <button @click="searchFilter">
          <img src="../../assets/images/search.svg" alt="" />
          <span>Search</span>
        </button>
      </div>
    </div>
    <div class="content-wrapper">
      <div class="content-wrapper__table">
        <Loader v-if="loader" />
        <table v-if="!loader && depositItems.length">
          <thead>
            <tr>
              <td>id</td>
              <td>UserId</td>
              <td>Amount</td>
              <td>Status</td>
              <td>Payment System</td>
              <td>Payment Gm Gateway</td>
              <td>Payment Invoice</td>
              <td>Profit invoice</td>
              <td>Received</td>
              <td>Date</td>
              <td>APPROVED</td>
            </tr>
          </thead>
          <tbody>
            <DepositTableRow v-for="row in depositItems" :row="row" :key="row.id" />
          </tbody>
        </table>
        <p class="msgError" v-if="!loader && !depositItems.length">Нет совпадений</p>
      </div>
    </div>
    <div class="bottom-wrapper" v-if="totalPagesCount">
      <div class="bottom-wrapper__info">
        <p>Страница {{ pageNumber }} из {{ totalPagesCount }}</p>
      </div>
      <div class="bottom-wrapper__pag">
        <div
          class="bottom-wrapper__pag-prev"
          :class="{ disable: pageNumber === 1 }"
          @click="changePage(-1)"
        >
          <svg
            width="9"
            height="15"
            viewBox="0 0 9 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.81251 8.23954L6.70834 14.125C6.80518 14.2226 6.92039 14.3001 7.04732 14.353C7.17426 14.4058 7.31041 14.4331 7.44793 14.4331C7.58544 14.4331 7.72159 14.4058 7.84853 14.353C7.97546 14.3001 8.09067 14.2226 8.18751 14.125C8.38152 13.9298 8.49042 13.6658 8.49042 13.3906C8.49042 13.1154 8.38152 12.8514 8.18751 12.6562L3.03126 7.44787L8.18751 2.29162C8.38152 2.09645 8.49042 1.83244 8.49042 1.55725C8.49042 1.28205 8.38152 1.01804 8.18751 0.822872C8.09104 0.724447 7.97599 0.646145 7.84904 0.592503C7.72208 0.53886 7.58575 0.510945 7.44793 0.510373C7.31011 0.510945 7.17377 0.53886 7.04682 0.592502C6.91986 0.646145 6.80482 0.724447 6.70834 0.822872L0.81251 6.70829C0.706775 6.80583 0.622391 6.92422 0.564675 7.05599C0.50696 7.18776 0.477163 7.33006 0.477163 7.47391C0.477163 7.61777 0.50696 7.76006 0.564675 7.89183C0.622391 8.0236 0.706775 8.14199 0.81251 8.23954Z"
              fill="#B8B8B8"
            />
          </svg>
        </div>
        <div class="bottom-wrapper__pag-items"></div>
        <div
          class="bottom-wrapper__pag-next"
          :class="{ disable: pageNumber === totalPagesCount }"
          @click="changePage(1)"
        >
          <svg
            width="9"
            height="15"
            viewBox="0 0 9 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.18751 8.23954L2.29168 14.125C2.19484 14.2226 2.07964 14.3001 1.9527 14.353C1.82576 14.4058 1.68961 14.4331 1.5521 14.4331C1.41459 14.4331 1.27843 14.4058 1.1515 14.353C1.02456 14.3001 0.909351 14.2226 0.812514 14.125C0.618503 13.9298 0.509605 13.6658 0.509605 13.3906C0.509605 13.1154 0.618503 12.8514 0.812514 12.6562L5.96876 7.44787L0.812513 2.29162C0.618502 2.09645 0.509604 1.83244 0.509604 1.55725C0.509604 1.28205 0.618502 1.01804 0.812513 0.822872C0.908987 0.724447 1.02403 0.646145 1.15099 0.592503C1.27794 0.53886 1.41428 0.510945 1.5521 0.510373C1.68992 0.510945 1.82625 0.53886 1.95321 0.592502C2.08016 0.646145 2.19521 0.724447 2.29168 0.822872L8.18751 6.70829C8.29325 6.80583 8.37763 6.92422 8.43535 7.05599C8.49306 7.18776 8.52286 7.33006 8.52286 7.47391C8.52286 7.61777 8.49306 7.76006 8.43535 7.89183C8.37763 8.0236 8.29325 8.14199 8.18751 8.23954Z"
              fill="#B8B8B8"
            />
          </svg>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Loader from '../../components/Loader/Loader'
import DepositTableRow from '../../components/DepositTableRow/DepositTableRow'

import './deposit.scss'

export default {
  name: 'Deposits',
  components: {
    DepositTableRow,
    Loader
  },
  created() {
    this.getAllItems()
  },
  data() {
    return {
      selectOpen: false,
      selectStatusOpen: false,
      loader: true,
      depositItems: [],
      pageNumber: 1,
      totalPagesCount: 0,
      currencyMap: {
        rub: '₽',
        usd: '$',
        eur: '€'
      },
      statusArray: ['paid', 'created'],
      searchPanel: {
        id: '',
        currency: '',
        paymentSystem: '',
        isStatusApproved: false,
        userId: '',
        status: '',
        paymentSystemInvoice: ''
      },
      searchPayload: '',
      controller: null
    }
  },
  methods: {
    getAllItems(payload) {
      this.loader = true
      if (this.controller) {
        this.controller.abort()
      }
      this.controller = new AbortController()
      fetch(
        `https://payments.neuralgeneration.com/api/v1/topups/fetch_all?page=${
          this.pageNumber
        }&count=20${payload ? payload : ''}`,
        {
          signal: this.controller.signal,
          method: 'GET',
          headers: {
            Authorization: `Bearer ${this.$store.state.tokens.access}`
          }
        }
      )
        .then((res) => res.json())
        .then((data) => {
          if (data.topups) {
            this.depositItems = data.topups
          } else {
            this.depositItems = []
          }
          this.totalPagesCount = data.totalPagesCount
          this.loader = false
        })
        .then(() => {
          this.controller = null
        })
    },
    changePage(direction) {
      if (direction + this.pageNumber <= this.totalPagesCount && direction === 1) {
        this.pageNumber += 1
      } else if (direction + this.pageNumber > 0 && direction === -1) {
        this.pageNumber -= 1
      }
      this.getAllItems(this.searchPayload)
    },
    openSelect() {
      this.selectOpen = !this.selectOpen
    },
    openSelectStatus() {
      this.selectStatusOpen = !this.selectStatusOpen
    },
    selectCurrency(key) {
      this.searchPanel.currency = key
      this.selectOpen = false
    },
    selectStatus(status) {
      this.searchPanel.status = status
      this.selectStatusOpen = false
    },
    approvedCheckBox() {
      this.searchPanel.isStatusApproved = !this.searchPanel.isStatusApproved
    },
    searchFilter() {
      this.searchPayload = ''
      for (let key in this.searchPanel) {
        if (this.searchPanel[key]) {
          this.searchPayload += `&${key}=${this.searchPanel[key]}`
        }
      }
      this.pageNumber = 1
      this.getAllItems(this.searchPayload)
    }
  }
}
</script>
